var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveroo = function SvgDeliveroo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.467.768-1.03 10.211-1.757-8.61-5.54 1.216 1.74 8.61-7.974 1.76 1.42 6.866 14.037 3.117 3.21-7.483 1.52-15.071-5.626-.616Zm-4.442 14.824c-.287.282-.66.247-1.081.106-.406-.141-.575-.634-.44-1.268.119-.458.642-.528.93-.528a.64.64 0 0 1 .304.07c.185.088.506.282.574.564.101.422 0 .774-.287 1.056Zm4.07.458c-.219.387-.76.44-1.317.158-.372-.193-.372-.651-.32-.95a.849.849 0 0 1 .185-.44c.135-.176.355-.405.591-.405.422-.018.76.176.963.528.203.352.101.74-.101 1.109Z",
    fill: "#36B7B1"
  })));
};
export default SvgDeliveroo;